module.exports = __webpack_public_path__ + "static/media/weak.18c0a2c3.svg";